import React from 'react'
import { number, shape, string } from 'prop-types'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { H4 } from '@fs/zion-ui'

const details = css`
  margin: 3px 10px;
`
const ordWrapper = css`
  display: flex;
  margin: 15px 0;
  flex-direction: column;
`

export default function OrdinanceCard({ ord }) {
  const { t } = useTranslation()

  const bornInCovenantLabel = t('wcf.person-ordinances.born-in-covenant', 'Born in the Covenant')
  const isBornInCovenant = ord.status === 'BORN_IN_COVENANT'

  return (
    <div css={ordWrapper}>
      <H4 size='H5'>{ord.name}</H4>
      {ord.completedDate && <div css={details}>{ord.completedDate}</div>}
      {ord.completedPlace && <div css={details}>{ord.completedPlace}</div>}
      {ord.unknown && <div css={details}>{ord.unknown}</div>}
      {isBornInCovenant && <div css={details}>{bornInCovenantLabel}</div>}
    </div>
  )
}

OrdinanceCard.propTypes = {
  ord: shape({
    status: string,
    completedDate: string,
    completedPlace: string,
    key: number,
    name: string,
  }),
}
